"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
var _regeneratorRuntime2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _upload = require("../../api/upload.js");
var _app = require("../../api/app.js");
var _inkhubMonthly = require("../../api/inkhubMonthly.js");
var _apprepair = require("../../api/apprepair.js");
var _awsSdk = _interopRequireDefault(require("aws-sdk"));
var _aliOss = _interopRequireDefault(require("ali-oss"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function createBlock() {
  return {
    language: "",
    theme: "",
    bannerUrl: "",
    bannerPreview: "",
    articleUrl: "",
    articleFileName: "上传",
    articleLoading: false
  };
}
var blockFieldRules = {
  bannerUrl: [{
    required: true,
    message: "请上传banner",
    trigger: "change"
  }],
  articleUrl: [{
    required: true,
    message: "请上传文章",
    trigger: "change"
  }]
};
var _default = exports.default = {
  name: "AddInkhubMonthly",
  data: function data() {
    return {
      formLabelWidth: "120px",
      isDisable: false,
      type: [],
      bannerDialogVisible: false,
      dialogBannerUrl: "",
      blocks: [createBlock()],
      privateKey_1: "XAkWgD0A",
      privateKey_2: "KSVDWG",
      keyId: "K66NRBmhuzqh6QX36ICAKIAVT4",
      secretId: "zlMc+UDjkbfloun7DrYRHfJQNupFNQfZuKHd49NL8jqu2x"
    };
  },
  computed: {
    blockRules: function blockRules() {
      var vm = this;
      return (0, _objectSpread2.default)({
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "change"
        }, {
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback();
              return;
            }
            var duplicateCount = vm.blocks.filter(function (block) {
              return block.language === value;
            }).length;
            if (duplicateCount > 1) {
              callback(new Error("语言不能重复"));
            } else {
              callback();
            }
          },
          trigger: "change"
        }],
        theme: [{
          required: true,
          message: "请填写网页标题",
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (!value || !String(value).trim()) {
              callback(new Error("请填写网页标题"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }, blockFieldRules);
    }
  },
  mounted: function mounted() {
    var _this = this;
    (0, _apprepair.getLanList)({
      name: "lan"
    }).then(function (res) {
      _this.type = res.dictionaryVOList || [];
    });
  },
  methods: {
    previewBanner: function previewBanner(url) {
      this.dialogBannerUrl = url;
      this.bannerDialogVisible = true;
    },
    addBlock: function addBlock() {
      this.blocks.push(createBlock());
    },
    removeBlock: function removeBlock(index) {
      var _this2 = this;
      this.blocks.splice(index, 1);
      this.$nextTick(function () {
        _this2.blocks.forEach(function (_, i) {
          _this2.validateBlockField(i, "language");
        });
      });
    },
    isLanguageUsed: function isLanguageUsed(valueCn, currentIndex) {
      return this.blocks.some(function (block, index) {
        return index !== currentIndex && block.language === valueCn;
      });
    },
    onLanguageChange: function onLanguageChange(index) {
      var _this3 = this;
      var value = this.blocks[index].language;
      if (!value) {
        return;
      }
      var duplicateIndex = this.blocks.findIndex(function (block, i) {
        return i !== index && block.language === value;
      });
      if (duplicateIndex !== -1) {
        this.blocks[index].language = "";
        this.msgTip("error", "\u8BED\u8A00\u300C".concat(value, "\u300D\u5DF2\u5728\u677F\u5757 ").concat(duplicateIndex + 1, " \u4E2D\u4F7F\u7528\uFF0C\u4E0D\u80FD\u91CD\u590D"));
      }
      this.$nextTick(function () {
        _this3.blocks.forEach(function (_, i) {
          _this3.validateBlockField(i, "language");
        });
      });
    },
    beforeUploadBanner: function beforeUploadBanner(file, index) {
      var _this4 = this;
      if (!file.type || file.type.indexOf("image/") !== 0) {
        this.msgTip("warning", "请上传图片文件");
        return false;
      }
      var fd = new FormData();
      fd.append("file", file);
      var req = new XMLHttpRequest();
      req.open("GET", document.location, false);
      req.send(null);
      var userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : "";
      var handleSuccess = function handleSuccess(res) {
        if (res.success) {
          _this4.blocks[index].bannerPreview = _this4.splitDownloadUrl(res.voT.downloadUrl);
          _this4.blocks[index].bannerUrl = res.voT.downloadUrl;
          _this4.validateBlockField(index, "bannerUrl");
        } else {
          _this4.msgTip("error", res.errorMsg);
        }
      };
      if (userType == "cn") {
        (0, _upload.ufileUpload)(fd).then(function (res) {
          handleSuccess(res);
        }).catch(function () {
          _this4.msgTip("error", "banner上传失败");
        });
      } else {
        (0, _upload.awsUpload)(fd).then(function (res) {
          handleSuccess(res);
        }).catch(function () {
          _this4.msgTip("error", "banner上传失败");
        });
      }
      return false;
    },
    submitArticleUpload: function submitArticleUpload(index) {
      var _this5 = this;
      var ref = this.$refs["articleUpload" + index];
      var input = Array.isArray(ref) ? ref[0] : ref;
      var fileData = input && input.files ? input.files[0] : null;
      if (!fileData) {
        return;
      }
      if (!/\.html?$/i.test(fileData.name) && fileData.type !== "text/html" && fileData.type !== "application/xhtml+xml") {
        this.msgTip("warning", "请上传 html 文件");
        input.value = null;
        return;
      }
      this.blocks[index].articleLoading = true;
      this.isDisable = true;

      // 与 applicationStore APK 上传一致
      var req = new XMLHttpRequest();
      req.open("GET", document.location, false);
      req.send(null);
      var userType = req.getResponseHeader("Domain") ? req.getResponseHeader("Domain") : "";
      (0, _app.appAapply)({
        fileName: fileData.name,
        folder: "1"
      }).then(function (res) {
        if (!res.success) {
          _this5.blocks[index].articleLoading = false;
          _this5.isDisable = false;
          _this5.msgTip("error", res.errorMsg || "申请上传失败");
          input.value = null;
          return;
        }
        var fileNames = res.s3Url.substr(res.s3Url.lastIndexOf("/", res.s3Url.lastIndexOf("/") - 1) + 1);
        // Domain 判断取链接：cn → ufile域名+路径，com → s3Url
        var downloadUrl = userType == "cn" ? String(res.ufileUrl || "").replace(/\/$/, "") + "/" + fileNames : res.s3Url;
        if (!downloadUrl || downloadUrl === "/" + fileNames) {
          _this5.blocks[index].articleLoading = false;
          _this5.isDisable = false;
          _this5.msgTip("error", userType == "cn" ? "未返回 ufileUrl" : "未返回 s3Url");
          input.value = null;
          return;
        }
        if (userType == "cn") {
          var _accessKeyId = _this5.decryption(res.accessKeyId);
          var accessKeySecret = _this5.decryption(res.accessKeySecret);
          var bucket = res.bucketName;
          var clientOssAli = new _aliOss.default({
            accessKeyId: _accessKeyId,
            accessKeySecret: accessKeySecret,
            bucket: bucket,
            endpoint: "supernote.com.cn"
          });
          _this5.startUpload(fileData, clientOssAli, fileNames, downloadUrl, index, input);
        } else {
          var decryptedPart1 = _this5.keyId.slice(-7);
          var decryptedPart2 = _this5.keyId.slice(-14, -7).split("").reverse().join("");
          var decryptedPart3 = _this5.keyId.slice(0, -14).slice(0, -6).split("").reverse().join("");
          var accessKeyId = decryptedPart1 + decryptedPart2 + decryptedPart3;
          var secretdecryptedPart1 = _this5.secretId.slice(-15);
          var secretdecryptedPart2 = _this5.secretId.slice(-31, -15).split("").reverse().join("");
          var secretreversedPart3 = _this5.secretId.slice(0, -31).slice(0, -6).split("").reverse().join("");
          var secretAccessKey = secretdecryptedPart1 + secretdecryptedPart2 + secretreversedPart3;
          var s3 = new _awsSdk.default.S3({
            accessKeyId: accessKeyId,
            secretAccessKey: secretAccessKey,
            region: "ap-northeast-1"
          });
          var _bucket = res.bucketName;
          // 与 APK 一致显式设 ContentType，html 用 text/html
          var contentType = "text/html";
          var params = {
            Bucket: _bucket,
            Key: fileNames,
            ContentType: contentType,
            ACL: "public-read"
          };
          s3.getSignedUrl("putObject", params, function (error, url) {
            if (error) {
              console.error("获取预签名URL失败：", error);
              _this5.blocks[index].articleLoading = false;
              _this5.isDisable = false;
              _this5.msgTip("error", "文章上传失败");
              input.value = null;
              return;
            }
            var xhr = new XMLHttpRequest();
            xhr.open("PUT", url, true);
            xhr.setRequestHeader("Content-Type", contentType);
            xhr.onreadystatechange = function () {
              if (xhr.readyState === XMLHttpRequest.DONE) {
                _this5.blocks[index].articleLoading = false;
                _this5.isDisable = false;
                if (xhr.status === 200) {
                  _this5.blocks[index].articleUrl = downloadUrl;
                  _this5.validateBlockField(index, "articleUrl");
                  input.value = null;
                } else {
                  _this5.msgTip("error", "文章上传失败");
                  input.value = null;
                }
              }
            };
            xhr.send(fileData);
          });
        }
      }).catch(function () {
        _this5.blocks[index].articleLoading = false;
        _this5.isDisable = false;
        _this5.msgTip("error", "文章上传失败");
        input.value = null;
      });
    },
    // 阿里云 OSS 上传（与 applicationStore.startUpload 一致）
    startUpload: function () {
      var _startUpload = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(fileData, clientOssAli, innerName1, downloadUrl, index, input) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return clientOssAli.multipartUpload("/" + innerName1, fileData, {
                headers: {
                  "Content-Type": "text/html"
                }
              });
            case 3:
              this.blocks[index].articleLoading = false;
              this.isDisable = false;
              this.blocks[index].articleUrl = downloadUrl;
              this.validateBlockField(index, "articleUrl");
              input.value = null;
              _context.next = 17;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.error("UploadError:", _context.t0);
              this.blocks[index].articleLoading = false;
              this.isDisable = false;
              this.msgTip("error", "文章上传失败");
              input.value = null;
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 10]]);
      }));
      function startUpload(_x, _x2, _x3, _x4, _x5, _x6) {
        return _startUpload.apply(this, arguments);
      }
      return startUpload;
    }(),
    decryption: function decryption(encryptionStr) {
      if (encryptionStr === null || encryptionStr === "") {
        return encryptionStr;
      }
      var decryptedStr = "";
      var length = Math.ceil(encryptionStr.length / 2);
      for (var i = 0; i < length; i++) {
        var charCode = parseInt(encryptionStr.substring(i * 2, i * 2 + 2), 16) - 1;
        decryptedStr += String.fromCharCode(charCode);
      }
      var startIndex = this.privateKey_1.length;
      var endIndex = decryptedStr.length - this.privateKey_2.length;
      endIndex = Math.max(endIndex, 0);
      return decryptedStr.substring(startIndex, endIndex);
    },
    validateBlockField: function validateBlockField(index, field) {
      var _this6 = this;
      this.$nextTick(function () {
        var ref = _this6.$refs["blockForm" + index];
        var form = Array.isArray(ref) ? ref[0] : ref;
        if (form) {
          form.validateField(field);
        }
      });
    },
    validateBlockForms: function validateBlockForms() {
      var _this7 = this;
      var tasks = this.blocks.map(function (block, index) {
        return new Promise(function (resolve) {
          var ref = _this7.$refs["blockForm" + index];
          var form = Array.isArray(ref) ? ref[0] : ref;
          if (!form) {
            resolve(false);
            return;
          }
          form.validate(function (valid) {
            return resolve(valid);
          });
        });
      });
      return Promise.all(tasks).then(function (results) {
        return results.every(Boolean);
      });
    },
    submit: function submit() {
      var _this8 = this;
      this.validateBlockForms().then(function (blocksValid) {
        if (!blocksValid) {
          _this8.msgTip("warning", "请完整填写各板块信息");
          return;
        }
        var languageSet = new Set(_this8.blocks.map(function (item) {
          return item.language;
        }));
        if (languageSet.size !== _this8.blocks.length) {
          _this8.msgTip("error", "各板块语言不能重复");
          return;
        }
        _this8.doSubmit();
      });
    },
    doSubmit: function doSubmit() {
      var _this9 = this;
      this.isDisable = true;
      (0, _inkhubMonthly.addInkhubMonthly)({
        theme: this.blocks[0].theme.trim(),
        languages: this.blocks.map(function (block) {
          return {
            language: block.language,
            theme: block.theme.trim(),
            bannerUrl: block.bannerUrl,
            articleUrl: block.articleUrl
          };
        })
      }).then(function (res) {
        _this9.isDisable = false;
        if (res.success) {
          _this9.msgTip("success", "添加成功");
          _this9.$store.dispatch("tagsView/delView", _this9.$route).then(function () {
            _this9.$nextTick(function () {
              _this9.$router.replace({
                path: "/other/inkhubMonthly",
                query: {
                  cur: _this9.$route.query.cur
                }
              });
            });
          });
        } else {
          _this9.msgTip("error", res.errorMsg);
        }
      }).catch(function () {
        _this9.isDisable = false;
        _this9.msgTip("error", "添加失败");
      });
    },
    splitDownloadUrl: function splitDownloadUrl(url) {
      if (!url) {
        return "";
      }
      return url + (url.indexOf("?") > -1 ? "&" : "?") + "t=" + new Date().getTime();
    },
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    }
  }
};